export default {
    methods: {
        alphabetSort(data, value = 'name') {
            return data.sort(function(a, b) {
                const courseA = a[value].toUpperCase();
                const courseB = b[value].toUpperCase();

                return (courseA < courseB) ? -1 : (courseA > courseB) ? 1 : 0;
            });
        }
    }
};
